
import React, { useEffect, useState } from 'react'
import NotificationList from './section/NotificationList';
import AddNotification from './section/AddNotification';
import { getNotificationListApi } from 'services/notification';
import { toastMessage } from 'utils/toastMessage';
import useFullPageLoader from 'common/UseFullPageLoader';
import { useSearchParams } from 'react-router-dom';

const NotificationManagement = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [loader, onShow, onHide] = useFullPageLoader();
    const [total, setTotal] = useState(0);
    const [notificationList, setNotificationList] = useState([])
    const activePage = +searchParams.get("page") || 1;

    //-------------get-Notification-List------------------
    const getNotificationList = async (
        page = activePage,
    ) => {
        try {
            onShow();
            const res = await getNotificationListApi({ page });
            if (res?.data?.status === 200) {
                const data = res.data.data
                setTotal(data?.total || 0);
                setNotificationList(data?.list);
                onHide();
            } else {
                toastMessage(res?.data?.message || 'Bad request', "error", "notificationList");
            }
        } catch (e) {
            onHide();
            toastMessage(e.message, "error", "notificationListCatch");
        }
    };
    useEffect(() => {
        getNotificationList()
        if (Number(activePage) === 1) {
            searchParams.delete("page");
            setSearchParams(searchParams);
        }
    }, [activePage])

    return (
        <>
            <AddNotification {...{
                getNotificationList
            }} />

            <NotificationList {...{
                loader,
                onHide,
                notificationList,
                activePage,
                total,
                searchParams,
                setSearchParams
            }} />
        </>
    )
}

export default NotificationManagement